import { Component, OnInit, Optional, Inject, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA} from "@angular/material/dialog";
import { GlobalCompanyService } from '../../../../shared/component/global-company/global-company.service';
import { FuseConfirmDialogComponent } from '../../../../../@fuse/components/confirm-dialog/confirm-dialog.component';
import { PolicyselectionService } from '../policyselection.service';
import { Router, RouterModule } from '@angular/router';
import { NotificationService, ValidationService } from '../../../../shared/services/service.index';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MatOptionModule, MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseAlertService } from '@fuse/components/alert';
import { DashboardNotificationModule } from 'app/shared/component/dashboard-notification/dashboard-notification.module';
export interface CompanyModel {
  companyId: number;
  entityId: number;
  pervEntityName: string;
  addFlag: boolean;
}

@Component({standalone:true,
  imports: [
    MatIconModule,
    ReactiveFormsModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatOptionModule,
    MatButtonModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
   
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatTooltipModule,
   
    RouterModule,
    FuseSharedModule,
    DashboardNotificationModule
  ],
  selector: 'app-policy-selection-entity-dailog-box',
  templateUrl: './policy-selection-entity-dailog-box.component.html',
  styleUrls: ['./policy-selection-entity-dailog-box.component.css'],providers: [GlobalCompanyService,PolicySelectionEntityDailogBoxComponent] 
})
export class PolicySelectionEntityDailogBoxComponent implements OnInit {

  entityForm: FormGroup;
  apiResponseErrorMessage: string = null;
  addconfirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
  companyId: number;
  entityId: number;
  notificationService: NotificationService;

  autoCompleteFormEntity: FormControl;

  entityFilter: any;
  entityAutoCompleteList: any[];
  entityList: any[] = [];
  entityName: string = "";

  entityStr: string;
  isCopyFlag: boolean = false;
  
  isAddEntity: boolean = false;

  private unsubscribeAll: Subject<any>;

  constructor(private formBuilder: FormBuilder,
    public matDialogRef: MatDialogRef<PolicySelectionEntityDailogBoxComponent>,
    private globalCompanyService: GlobalCompanyService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: CompanyModel,
    private matDialog: MatDialog,
    private globalCompanyServcie: GlobalCompanyService,
    public fuseAlertService: FuseAlertService,
    private _policySelectionService: PolicyselectionService,
    private snb: MatSnackBar,
    private _router: Router,private cd: ChangeDetectorRef)
  {
    this.notificationService = new NotificationService(snb)
    
    // this.globalCompanyServcie.globalCompany.subscribe(res => {
    //   if (res === 0) {
    //     this._router.navigate([AppRoute.dashboard]);
    //     return;
    //   } else {
    //     this.companyId = res;
    //   }
    // });
    //this.globalCompanyServcie.globalEntity.subscribe(res => {
    //  if (res === 0) {
    //    this._router.navigate([AppRoute.dashboard]);
    //    return;
    //  } else {
    //      this.entityId = res;
    //  }
    //});
    this.unsubscribeAll = new Subject();
    this.autoCompleteFormEntity = new FormControl();
  }

  ngOnInit() {
    
    this.entityForm = this.formBuilder.group({
      id: [(this.data.addFlag ? 0 :this.data.entityId)],
      name: [(this.data.entityId != 0 && !this.data.addFlag ? this.data.pervEntityName : ''), [Validators.required, ValidationService.noWhiteSpace, Validators.maxLength(30)]]
    });
    if (this.entityForm.controls.id.value == 0) {
      this.entityId = this.data.entityId;
      this.companyId = this.data.companyId;
      this.isAddEntity = true;
      this.bindEntityDropDown();
   
    }
      
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next('');
    this.unsubscribeAll.complete();
  }

  bindEntityDropDown() {
    
    this._policySelectionService.getEntitiesByCompany(this.companyId).subscribe(resultEntities => {

      this.entityAutoCompleteList = [];
      this.entityList = [];
      this.entityAutoCompleteList = resultEntities.data;
//console.log("list from dropdown", this.entityAutoCompleteList)
      this.entityList = resultEntities.data;
     // this.entityId = entityOption.value;
      this.showTextEntity();
    });
  }

  onInputChangedEntity(searchStr: string) {
    if (this.entityList.length != 0) {
      this.entityStr = searchStr;
      if (searchStr == null || searchStr == "") {
        this.entityAutoCompleteList = [];
        this.entityAutoCompleteList = this.entityList;
        //console.log("list from dropdown", this.entityAutoCompleteList)
      }
      else {
        this.entityAutoCompleteList = [];
        this.entityAutoCompleteList = this.entityList.filter(option => option.text.toLowerCase().includes(searchStr.toLowerCase()));
      }
    }
  }

  onFocusOutEntity() {
    if (this.entityStr == "" || this.entityStr == null || this.entityStr == undefined) {
      this.showTextEntity();
    }
  }

  showTextEntity(flag=false) {
    if (this.entityStr == "" || this.entityStr == undefined || flag) {
      if (this.entityId != 0) {
        this.entityStr = "";
        var entityObjIndex = this.entityList.findIndex(x => x.value == this.entityId);
        if (entityObjIndex >= 0) {
          this.entityName = this.entityList[entityObjIndex].text;
          this.autoCompleteFormEntity.setValue(this.entityName);
        }

      }
    }
  }

  displayFnAutoComplete(rv) {
    return rv;
  }

  onChangeEntity(entityOption) {
    if (entityOption.value != this.entityId) {
      this.entityId = entityOption.value;
      this.showTextEntity(true);
    }
    else
      this.showTextEntity();
  }

  onChangeIsCopy(event) {
    this.isCopyFlag = event.checked; 
    this.cd.detectChanges();
}


  submit() {
    
    if (this.entityForm.controls.id.value == 0) {
      this.addEntity(this.isCopyFlag);
    }
    else {
      var model = {
        companyId: this.data.companyId,
        entityId: this.entityForm.controls.id.value,
        name: this.entityForm.controls.name.value.trim().replace(/\s+/g, " ")
      };
      
      this._policySelectionService.editEntity(model).subscribe(result => {
        if (result.status == 1) {
          
          this.matDialogRef.close(['submit']);

          this._policySelectionService.addEditEntity(true);
        }
        this.fuseAlertService.show(result.message, result.status);
     
      });
    }
  }

  addEntity(isCopy) {
    
    var model = {
      companyId: this.data.companyId,
      isCopy: isCopy,
      entityId: (isCopy ? this.entityId : 0),
      name: this.entityForm.controls.name.value.trim().replace(/\s+/g, " ")
    };
    this._policySelectionService.addEntity(model).subscribe(result => {
      if (result.status == 1) {
        
        this.globalCompanyServcie.globalEntity = result.data;

        
      var model = {
        companyId: this.companyId,
        entityId:  result.data
      };
      this._policySelectionService.setEntityToCompany(model).subscribe(result => {
      
      });
        this.matDialogRef.close(result);

        this._policySelectionService.addEditEntity(true);
      }
      this.fuseAlertService.show(result.message, result.status);
   
    });
  }
}
